export default __webpack_public_path__ + "img/InterDisplay-Light_e69a42f.woff2";